import { ButtonBase, Stack } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	onClick: () => void;
	showDivider: boolean;
	children: ReactNode;
};

export const DashboardRowButton: FC<Props> = ({
	onClick,
	showDivider,
	children,
}) => {
	return (
		<ButtonBase
			onClick={onClick}
			sx={{
				width: "100%",
				textAlign: "left",
				borderBottom: showDivider ? 1 : 0,
				borderColor: "surface.border",
			}}
		>
			<Stack
				direction="row"
				alignItems="center"
				gap={1.2}
				px={1.6}
				py={1.2}
				width="100%"
			>
				{children}
			</Stack>
		</ButtonBase>
	);
};
